$(function() {
  
  // $('.cart-cta').hover(function() {
  //   $('.cart-box').addClass('active');
  // }, function() {
  //   setTimeout(function() {
  //     $('.cart-box').removeClass('active');
  //   }, 300);
  // });

  $('.cart-cta').click(function() {
    $('.cart-box').toggleClass('active');

    if (isMobile && $(window).width() < 992) {
      $('body').toggleClass('ohns');
    }
  });


  // $('.cart-box__list').hover(function() {
  //   $('body').addClass('ohns');
  // }, function() {
  //   $('body').removeClass('ohns');
  // });

});
